import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { layout, typography } from 'styled-system';
import { Link } from 'react-router-dom';

import CheckLandsButtonImage from '../../../assets/search.png';

const Wrapper = styled.div`
  width: 40%;
  margin-left: auto;
  user-select: none;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #fff;
  user-select: none;
`;

const Flex = styled.div`
  display: flex;
  justify-content: flex-end;
  user-select: none;
`;

const Image = styled.img`
  margin: auto 8px auto 0;

  ${layout}
`;

const Text = styled.span`
  letter-spacing: 2px;
  margin: auto 0;

  ${typography}
`;

const CheckLandsButton = ({ children }) => {
  return (
    <Wrapper>
      <StyledLink to="/lands">
        <Flex>
          <Image src={CheckLandsButtonImage} width={['10%', '5%']} />
          <Text fontSize={['14px', '14px', '16px']}>{children}</Text>
        </Flex>
      </StyledLink>
    </Wrapper>
  );
};

CheckLandsButton.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CheckLandsButton;
